import styled from 'styled-components'  
 
export const DashboardPage = styled.div.attrs({ 
})`            
    flex: 1;
`;

export const DashboardBody = styled.div.attrs({ 
})`       
    min-height: calc(100vh - 90px);
    max-height: calc(100vh - 90px);
    background: ${ props => props.theme.palette.colors.backgrounddarkgrey };

    display: flex;
    align-items: flex-start;     
    overflow:auto;
`;

export const DashboardBodyContent = styled.div.attrs({ 
})`            
    margin: 24px;
    background: ${ props => props.theme.palette.colors.backgrounddarkgrey };
    padding: 35px 20px;
    width: 100%;
    border-radius: 11px;
    min-height: calc(100vh - 138px);
`;

export const Content = styled.div.attrs({ 
})`           
    overflow:hidden;
    display: flex;
`; 